import { useBaseAPI } from 'apiServices/baseAPI';
import { oids, endpoints, currentMode } from 'configs';

export function useDocumentReferenceAPI({
  resourceId,
  organizationId,
  purposeOfUse,
  subjectId,
  subjectToken,
  category,
}) {
  return useBaseAPI(
    {
      method: 'GET',
      route: `${
        endpoints.MHD.split(`${endpoints.XDSB_domain}/`)[1]
      }/DocumentReference?subject:Patient.identifier=urn:oid:${
        resourceId.length === 11 ? oids.cpf : oids.cns
      }%7C${resourceId}&category=${category}&status=current&_count=5&_sort=-period`,
      additionalHeaders: {
        purposeofuse: purposeOfUse || 'Atendimento',
        ...(organizationId && { 'organization-id': organizationId }),
        ...(subjectId && { 'subject-id': subjectId }),
        ...(resourceId &&
          currentMode === 'aghu' && { 'resource-id': resourceId }),
        ...(subjectToken && { authorization: `Bearer ${subjectToken}` }),
        ...(subjectToken && { 'x-user-token': subjectToken }),
      },
    },
    !resourceId,
  );
}
